export default function MicIcon() {
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g id='mic'>
        <mask
          id='mask0_442_252238'
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='18'
          height='18'
        >
          <rect id='Bounding box' width='18' height='18' fill='#D9D9D9' />
        </mask>
        <g mask='url(#mask0_442_252238)'>
          <path
            id='mic_2'
            d='M9 10.5C8.375 10.5 7.84375 10.2812 7.40625 9.84375C6.96875 9.40625 6.75 8.875 6.75 8.25V3.75C6.75 3.125 6.96875 2.59375 7.40625 2.15625C7.84375 1.71875 8.375 1.5 9 1.5C9.625 1.5 10.1562 1.71875 10.5938 2.15625C11.0312 2.59375 11.25 3.125 11.25 3.75V8.25C11.25 8.875 11.0312 9.40625 10.5938 9.84375C10.1562 10.2812 9.625 10.5 9 10.5ZM8.25 15.75V13.4438C6.95 13.2688 5.875 12.6875 5.025 11.7C4.175 10.7125 3.75 9.5625 3.75 8.25H5.25C5.25 9.2875 5.61563 10.1719 6.34688 10.9031C7.07812 11.6344 7.9625 12 9 12C10.0375 12 10.9219 11.6344 11.6531 10.9031C12.3844 10.1719 12.75 9.2875 12.75 8.25H14.25C14.25 9.5625 13.825 10.7125 12.975 11.7C12.125 12.6875 11.05 13.2688 9.75 13.4438V15.75H8.25ZM9 9C9.2125 9 9.39062 8.92813 9.53438 8.78438C9.67812 8.64063 9.75 8.4625 9.75 8.25V3.75C9.75 3.5375 9.67812 3.35938 9.53438 3.21563C9.39062 3.07188 9.2125 3 9 3C8.7875 3 8.60938 3.07188 8.46562 3.21563C8.32188 3.35938 8.25 3.5375 8.25 3.75V8.25C8.25 8.4625 8.32188 8.64063 8.46562 8.78438C8.60938 8.92813 8.7875 9 9 9Z'
            fill='currentColor'
          />
        </g>
      </g>
    </svg>
  );
}
